import { Currency } from './Currency';
import { BasePagingResponse, BaseResponse } from './_base';

export enum PromoCodeStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  REDEEMED = 'REDEEMED',
  DELETED = 'DELETED',
}

export enum PromoCodeType {
  PERCENT = 'PERCENT',
  AMOUNT = 'AMOUNT',
}

export interface PromoCode {
  uid: string;
  code: string;
  status: PromoCodeStatus;
  type: PromoCodeType;
  value: number;
  currency: Currency | null;
  singleUsage: boolean;
  propertyUid: string | null;
  agencyUid: string;

  validFromZonedDateTime: any;
  validToZonedDateTime: any;
  expirationZonedDateTime: any;

  validFromUTCDateTime: string;
  validToUTCDateTime: string;
  expirationUTCDateTime: string;
}

export interface GetPromoCodesResponse
  extends BaseResponse,
    BasePagingResponse {
  promoCodes: PromoCode[];
}

export interface GetPromoCodeResponse {
  promoCode: PromoCode;
}

export interface CreatePromoCodePayload {
  propertyUid: string;
  singleUse: boolean;
  currency: Currency;
  name: string;
  type: PromoCodeType;
  value: number;
  validFromDate: string;
  validToDate: string;
  expirationDate: string;
}

export interface CreatePromoCodeResponse {
  promoCode: PromoCode;
}
